import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const customStyles = {
  content: {
    border: 'initial',
    background: 'initial'
  }
};

const ProductImageModal = ({ isOpen, onRequestClose, currentImageTitle, currentImageSrc }) => 
  (
    <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={customStyles}
    >
      <div className="modal-content">
        <div className="modal-header">
          <button onClick={onRequestClose} className="close"><span className="fa fa-times" /></button>
          <h4>{currentImageTitle}</h4>
        </div>
        <div className="modal-body text-center product-image-modal">
          <img alt={currentImageTitle} src={currentImageSrc} className="img-responsive product-image-modal--image" />
        </div>
      </div>
    </Modal>
  );

if (typeof(window) !== 'undefined' && !window.isServerSide) {
  //Modal.setAppElement('body')
}

ProductImageModal.propTypes = {
  currentImageSrc: PropTypes.string.isRequired,
  currentImageTitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired  
};

export default ProductImageModal;